import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PharmacieEditModalComponent } from './pharmacie-edit-modal/pharmacie-edit-modal.component';
import { ContactSupportModalComponent } from './contact-support-modal/contact-support-modal.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RealsizeImageModalComponent } from './realsize-image-modal/realsize-image-modal.component';
import { FormModule } from '../form/form.module';
import { PatientInformationModalComponent } from './patient-information-modal/patient-information-modal.component';
import { OrdonnanceStateModalComponent } from './ordonnance-state-modal/ordonnance-state-modal.component';
import { SmsClientComponent } from './sms-client/sms-client.component';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    PharmacieEditModalComponent,
    ContactSupportModalComponent,
    RealsizeImageModalComponent,
    PatientInformationModalComponent,
    OrdonnanceStateModalComponent,
    SmsClientComponent
  ],
  imports: [
    CommonModule,
    FormModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTooltipModule
  ],
  exports: [
    PharmacieEditModalComponent,
    ContactSupportModalComponent,
    RealsizeImageModalComponent,
    PatientInformationModalComponent,
    OrdonnanceStateModalComponent,
    SmsClientComponent
  ]
})
export class ModalModule { }
